module.exports = __webpack_public_path__ + "img/indasa.0f152be4.webp";